module.exports = __webpack_public_path__ + "assets/feded7dce95a340e0edd36a9c0ed720d.png";